export default "__VITE_ASSET__DXTQSF6$__"